module.exports = __webpack_public_path__ + "img/bg-5@2x.bfc8635a.jpg";